export default "__VITE_ASSET__22999d65__"